/**
 * @desc Export table layout configuration.
 * @example
 * import { layoutConfig } from 'config/table-configs/claim-detail';
 */
export const layoutConfig = {
    dimensions: {
        maxHeight: 260,
        padding: 0,
    },
    columnWidth: {
        rxNumber: 120,
        currentDrugName: 220,
        currentDrugCost: 120,
        alternateDrugName: 220,
        alternateDrugCost: 120,
        savings: 120,
        
        // special columns
        _selectionActions: 16, // checkbox selection
        _groupActions: 70, // group actions column
    },
    filterFlyoutWidths: {
        claimNumber: 200,
        rxNumber: 180,
        status: 300,
    },
    valueColors: {},
    actionIcons: {
        toDos: 'checkedContent',
    },
};
